import moment from "moment";
import {
  ROLE_USER_SUPER_ADMIN,
  ROLE_USER_GROUP_ADMIN
} from "@/config/constants";
import { getSingleItem } from "@/lib/apiClient/api";

export const isMobile = () => window.screen.width < 576;

export const formatMyDate = (value, string = false, format = "") => {
  const momentValue = moment(value, "YYYY/MM/DD").format();
  const date = new Date(momentValue);
  // const date = value instanceof Date ? value : new Date(value);
  const month = date.getMonth() + 1;
  const day = parseInt(date.getDate(), 10);
  let newDate;

  switch (format) {
    case "mm/dd/yyyy":
      newDate = `${month < 10 ? `0${month}` : month}/${
        day < 10 ? `0${day}` : day
      }/${date.getFullYear()}`;
      break;
    case "yyyy-mm-dd":
    default:
      newDate = `${date.getFullYear()}-${month < 10 ? `0${month}` : month}-${
        day < 10 ? `0${day}` : day
      }`;
  }

  return string ? newDate : new Date(newDate);
};

export const addDays = (numberOfDays, startDate = new Date()) => {
  const returnDate = new Date(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate() + numberOfDays,
    startDate.getHours(),
    startDate.getMinutes(),
    startDate.getSeconds()
  );
  return returnDate;
};

export const prepareItemsFromJSON = ({ data, urlIRI }) => {
  const options = [];

  const keys = Object.keys(data);

  keys.map((key) =>
    options.push({
      label: data[key],
      value: `${urlIRI}${key}`
    })
  );

  return options;
};

export const checkDate = (field, format = "yyyy-mm-dd", maxYear) => {
  // http://www.the-art-of-web.com/javascript/validate-date/
  const allowBlank = true;
  const minYear = 1902;
  // const maxYear = new Date().getFullYear();

  let errorMsg = "";

  // regular expression to match required date format
  let re;

  switch (format) {
    case "dd/mm/yyyy":
      re = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
      break;
    default:
      re = /^(\d{4})-(\d{1,2})-(\d{1,2})/;
  }

  if (field !== "" && typeof field === "string") {
    const regs = field.match(re);
    if (regs) {
      if (regs[3] < 1 || regs[3] > 31) {
        errorMsg = `Invalid value for day: ${regs[1]}`;
      } else if (regs[2] < 1 || regs[2] > 12) {
        errorMsg = `Invalid value for month: ${regs[2]}`;
      } else if (regs[1] < minYear || (maxYear && regs[1] > maxYear)) {
        errorMsg = `Invalid value for year: ${regs[1]} - must be between ${minYear} and ${maxYear}`;
      }
    } else {
      errorMsg = `Invalid date format: ${field}`;
    }
  } else if (!allowBlank) {
    errorMsg = "Empty date not allowed!";
  }

  if (errorMsg !== "") {
    // console.log(errorMsg);
    return false;
  }

  return true;
};

export const cleanObject = (obj) => {
  const object = obj;
  const propNames = Object.getOwnPropertyNames(obj);
  for (let i = 0; i < propNames.length; i++) {
    const propName = propNames[i];
    if (object[propName] === null || object[propName] === undefined) {
      delete object[propName];
    }
  }
};

export const isEmpty = (obj) =>
  [Object, Array].includes((obj || {}).constructor) &&
  !Object.entries(obj || {}).length;

// export const parseHtml = value => (
//   <div dangerouslySetInnerHTML={{ __html: value }} />
// );
export const parseHtml = (value) => <div>{value}</div>;

export const parseFromStaticData = (data, value, compareWith, display) => {
  const keys = Object.keys(data);
  const result = keys.filter((key) =>
    data[key][compareWith] === value ? data[key][display] : null
  );
  return isEmpty(result) ? null : `${result}`;
};

export const uniqArray = (arrArg) => [...new Set(arrArg)];

export const checkAccess = (checkAccessNeeded, userRoles) => {
  let haveAccess = false;
  let accessNeeded = [];

  if (!isEmpty(checkAccessNeeded)) {
    if (!Array.isArray(checkAccessNeeded)) {
      accessNeeded = [checkAccessNeeded];
    } else {
      accessNeeded = checkAccessNeeded;
    }
  }

  accessNeeded = uniqArray(accessNeeded.flat());

  if (isEmpty(userRoles)) {
    haveAccess = false;
  } else if (isEmpty(accessNeeded)) {
    haveAccess = true;
  } else {
    accessNeeded.map((access) => {
      if (userRoles.includes(access)) {
        haveAccess = true;
      }
      return true;
    });
  }

  return haveAccess;
};

export const accessLoginButton = (item, userRoles, loggedCommunityId) => {
  const now = new Date();
  const trial = new Date(item.trialExpirationDate);
  const status = item.status;
  const id = item.id;

  if (loggedCommunityId === id) {
    return false;
  }

  now.setHours(0, 0, 0, 0);
  trial.setHours(0, 0, 0, 0);

  // add is loggedCommunity check
  if (
    checkAccess(
      [ROLE_USER_SUPER_ADMIN, ROLE_USER_GROUP_ADMIN],
      userRoles,
      false
    ) ||
    (!(status === "trial" && trial < now) &&
      !["suspended", "deleted"].includes(status))
  ) {
    return true;
  }
  return false;
};

export const getCheckboxView = (value) => <tt>{value ? "[x]" : "[ ]"}</tt>;
// return <i className={`fas ${value ? "fa-check" : "fa-times"} fa-lg`} />;

export const doTriggerDownload = (content, fileName) => {
  const hiddenElement = document.createElement("a");
  hiddenElement.href = `data:text/csv;charset=utf-8,${encodeURIComponent(
    content
  )}`;
  hiddenElement.target = "_blank";
  hiddenElement.download = fileName;
  hiddenElement.click();
};

export const downloadFileFromUrl = (fileUrl) => {
  const hiddenElement = document.createElement("a");
  hiddenElement.href = `${fileUrl}`;
  hiddenElement.download = fileUrl.split("/").pop();
  hiddenElement.click();
};

// native upperFirst to remove lodash in future

export const upperFirst = (string) =>
  string ? string.charAt(0).toUpperCase() + string.slice(1) : "";

export const get = (obj, path, defaultValue = undefined) => {
  const travel = (regexp) =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce(
        (res, key) => (res !== null && res !== undefined ? res[key] : res),
        obj
      );
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
  return result === undefined || result === obj ? defaultValue : result;
};

export const calcImageFitSizes = (
  imgWidth,
  imgHeight,
  maxWidth = 200,
  maxHeight = 200
) => {
  if (!imgWidth || !imgHeight) {
    return [imgWidth, imgHeight];
  }

  if (!maxWidth) {
    maxWidth = imgWidth;
  }
  if (!maxHeight) {
    maxHeight = imgHeight;
  }

  const xRatio = maxWidth / imgWidth;
  const yRatio = maxHeight / imgHeight;

  let tnWidth;
  let tnHeight;

  if (imgWidth <= maxWidth && imgHeight <= maxHeight) {
    tnWidth = imgWidth;
    tnHeight = imgHeight;
  } else if (xRatio * imgHeight < maxHeight) {
    tnWidth = maxWidth;
    tnHeight = Math.ceil(xRatio * imgHeight);
  } else {
    tnWidth = Math.ceil(yRatio * imgWidth);
    tnHeight = maxHeight;
  }

  return [tnWidth, tnHeight];
};

export const secondsToHoursMinutesSecondsString = (seconds) =>
  new Date(seconds * 1000).toISOString().slice(11, 19);

export const secondsToFormattedDuration = (seconds, formatDefault = false) => {
  const totalSeconds = Math.max(0, Math.floor(seconds));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  if (formatDefault) {
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(secs).padStart(2, "0")}`;
  }

  return `${String(hours).padStart(2, "0")}h ${String(minutes).padStart(2, "0")}m ${String(secs).padStart(2, "0")}s`;
};

export const isFunction = (func) => typeof func === "function";

export const buildQueryKeys = (queryKey) => ({
  all: [queryKey],
  lists: () => [queryKey, "list"],
  list: (filters) => [queryKey, "list", { filters }],
  details: () => [queryKey, "detail"],
  detail: (id) => [queryKey, "detail", id?.toString()]
});

export const buildDetailsQuery = (keys, apiUrl) => {
  return (itemId) => ({
    queryKey: keys.detail(itemId),
    queryFn: async () => await getSingleItem(itemId, apiUrl)
  });
};

export const getMaxValue = (data, propertyName) =>
  !isEmpty(data) ? Math.max(...data?.items?.map((o) => o[propertyName])) : 0;

export const getIsImageTypeVisible = (loggedCommunity, imageType, entity) => {
  const { imageProfiles } = loggedCommunity || {}; // for screens where access is allowed even if not logged in community
  return imageProfiles?.some(
    (imageProfile) =>
      imageProfile?.groupType === imageType &&
      imageProfile?.forObject === entity
  );
};

export const getRecommendedImageSize = (loggedCommunity, entity, groupType) => {
  // groups are: "landscape", "portrait"
  const { imageProfiles } = loggedCommunity || {};
  const systemName = groupType === "landscape" ? "quadHD" : "portraitQuadHD";
  const quadHD = imageProfiles?.find(
    (imageProfile) =>
      imageProfile?.forObject === entity &&
      imageProfile?.groupType === groupType &&
      imageProfile?.systemName === systemName
  );
  const defaultSize = groupType === "landscape" ? "1920x1080" : "1920x685";
  return quadHD ? `${quadHD.xLimit}x${quadHD.yLimit}.` : defaultSize + ".";
};

export const buildUri = (entity, id) => `/api/v2/${entity}/${id}`;

export const generateServerKey = (length = 10) => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};
